import { put, select, takeLatest } from 'redux-saga/effects';
import { normalize } from 'normalizr';
import find from 'lodash/find';

import api from 'helpers/api';

import { getCurrentLanguage } from '../language/selectors';
import { getRegion } from '../region/selectors';

import {
  FETCH_FAQ_CATEGORIES_REQUEST,
  fetchFaqCategoriesSuccess,
  fetchFaqCategoriesFailure
} from './actions';

import * as schemas from 'schemas';

const PUBLISH_IN_REGION_MAP = {
  FI: 'Finland',
  NO: 'Norway',
  SE: 'Sweden'
};

function* handleFetchFaqCategoriesRequest() {
  try {
    const language = yield select(getCurrentLanguage);
    const region = yield select(getRegion);

    const { data } = yield api.contentful('entries', {
      params: {
        content_type: 'faqQuestion',
        locale: language,
        'fields.publishIn': PUBLISH_IN_REGION_MAP[region.countrycode]
      }
    });

    const categories = [];

    data.items.forEach(item => {
      const question = {
        id: item.sys.id,
        question: item.fields.question,
        answer: item.fields.answer
      };

      const questionCategories = item.fields.categories.map(category => {
        const id = category.sys.id;
        const entry = find(data.includes.Entry, e => e.sys.id === id);

        return {
          id: entry.sys.id,
          title: entry.fields.title
        };
      });

      questionCategories.forEach(questionCategory => {
        let foundCategory = find(categories, { id: questionCategory.id });

        let category;

        if (foundCategory) {
          category = foundCategory;
        } else {
          category = questionCategory;
        }

        if (category.questions) {
          category.questions.push(question);
        } else {
          category.questions = [question];
        }

        if (!foundCategory) {
          categories.push(category);
        }
      });
    });

    const response = normalize(categories, [schemas.faqCategory]);

    yield put(fetchFaqCategoriesSuccess(response));
  } catch (err) {
    yield put(fetchFaqCategoriesFailure(err));
  }
}

export default function* faqSaga() {
  yield takeLatest(
    FETCH_FAQ_CATEGORIES_REQUEST,
    handleFetchFaqCategoriesRequest
  );
}



// WEBPACK FOOTER //
// ./src/store/faq/sagas.js